import { isFrontierWorkPath } from '@internal/spassu-code-contract';
import type { Activity, Phase } from '../../api/types';

const CONFORMITY_APPROVAL_PHASES = new Set<Phase>([
  'gerando-prd',
  'gerando-techspec',
  'dividindo-tasks',
  'pronto',
]);

export function isPhaseConformityReadyForApproval(
  activity: Activity,
  phase: Phase,
): boolean {
  if (
    !isFrontierWorkPath(activity.workPath) ||
    !CONFORMITY_APPROVAL_PHASES.has(phase)
  ) {
    return true;
  }
  return (
    activity.phaseConformity?.phase === phase &&
    activity.phaseConformity.status === 'compliant'
  );
}
